<!-- This example requires Tailwind CSS v2.0+ -->

<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <footer class="bg-gray-100">
    <div class="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
      <nav
        class="-mx-5 -my-2 flex flex-wrap justify-center"
        aria-label="Footer"
      >
        <div class="px-5 py-2">
          <a
            href="/cookie-policy"
            target="_blank"
            class="text-base text-gray-500 hover:text-gray-900"
          >
            {{ $t("message.cookiePolicy") }}
          </a>
        </div>
        <div class="px-5 py-2">
          <a
            href="/privacy-policy"
            target="_blank"
            class="text-base text-gray-500 hover:text-gray-900"
          >
            {{ $t("message.privacyPolicy") }}
          </a>
        </div>
        <div class="px-5 py-2">
          <a
            href="/user-agreement"
            target="_blank"
            class="text-base text-gray-500 hover:text-gray-900"
          >
            {{ $t("message.userAgreement") }}
          </a>
        </div>
      </nav>
      <div class="mt-8 flex justify-center space-x-6">
        <a
          v-for="item in navigation"
          :key="item.name"
          :href="item.href"
          class="text-gray-400 hover:text-gray-500"
        >
          <span class="sr-only">{{ item.name }}</span>
          <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
        </a>
      </div>
      <p class="mt-8 text-center text-base text-gray-400">
        &copy; {{ year }} Emusavirim, Tüm Hakları Saklıdır
      </p>
    </div>
  </footer>

  <!--  <footer class="bg-white">-->
  <!--    <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">-->
  <!--      <div class="flex justify-center space-x-6 md:order-2">-->
  <!--        <a v-for="item in navigation" :key="item.name" :href="item.href" class="text-gray-400 hover:text-gray-500">-->
  <!--          <span class="sr-only">{{ item.name }}</span>-->
  <!--          <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />-->
  <!--        </a>-->
  <!--      </div>-->
  <!--      <div class="flex space-x-6 mt-8 md:mt-0 md:order-1">-->
  <!--        <p class="text-center text-base text-gray-400">-->
  <!--          &copy; {{ year }} Emusavirim, Tüm Hakları Saklıdır-->
  <!--        </p>-->
  <!--        <a href="/cookie-policy" target="_blank" class="text-center text-base text-gray-400">-->
  <!--         Çerez Politikası-->
  <!--        </a>-->
  <!--        <a href="/privacy-policy" target="_blank" class="text-center text-base text-gray-400">-->
  <!--          Gizlilik Politikası-->
  <!--        </a>-->
  <!--        <a href="/user-agreement" target="_blank"  class="text-center text-base text-gray-400">-->
  <!--          Kullanıcı Sözleşmesi-->
  <!--        </a>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </footer>-->
</template>

<script>
import { defineComponent, h } from "vue";

const navigation = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/emusavirim.net",
    icon: defineComponent({
      render: () =>
        h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
          h("path", {
            "fill-rule": "evenodd",
            d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
            "clip-rule": "evenodd",
          }),
        ]),
    }),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/emusavirimnet/",
    icon: defineComponent({
      render: () =>
        h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
          h("path", {
            "fill-rule": "evenodd",
            d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
            "clip-rule": "evenodd",
          }),
        ]),
    }),
  },
  {
    name: "Twitter",
    href: "https://twitter.com/emusavirimnet",
    icon: defineComponent({
      render: () =>
        h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
          h("path", {
            d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84",
          }),
        ]),
    }),
  },
  {
    name: "Youtube",
    href: "https://www.youtube.com/channel/UCiUeAA3J2rNXoXKr-BfKr4A",
    icon: defineComponent({
      render: () =>
        h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
          h("path", {
            d: "M 4.652 0 h 1.44 l 0.988 3.702 l 0.916 -3.702 h 1.454 l -1.665 5.505 v 3.757 h -1.431 v -3.757 l -1.702 -5.505 Z m 6.594 2.373 c -1.119 0 -1.861 0.74 -1.861 1.835 v 3.349 c 0 1.204 0.629 1.831 1.861 1.831 c 1.022 0 1.826 -0.683 1.826 -1.831 v -3.349 c 0 -1.069 -0.797 -1.835 -1.826 -1.835 Z m 0.531 5.127 c 0 0.372 -0.19 0.646 -0.532 0.646 c -0.351 0 -0.554 -0.287 -0.554 -0.646 v -3.179 c 0 -0.374 0.172 -0.651 0.529 -0.651 c 0.39 0 0.557 0.269 0.557 0.651 v 3.179 Z m 4.729 -5.07 v 5.186 c -0.155 0.194 -0.5 0.512 -0.747 0.512 c -0.271 0 -0.338 -0.186 -0.338 -0.46 v -5.238 h -1.27 v 5.71 c 0 0.675 0.206 1.22 0.887 1.22 c 0.384 0 0.918 -0.2 1.468 -0.853 v 0.754 h 1.27 v -6.831 h -1.27 Z m 2.203 13.858 c -0.448 0 -0.541 0.315 -0.541 0.763 v 0.659 h 1.069 v -0.66 c 0.001 -0.44 -0.092 -0.762 -0.528 -0.762 Z m -4.703 0.04 c -0.084 0.043 -0.167 0.109 -0.25 0.198 v 4.055 c 0.099 0.106 0.194 0.182 0.287 0.229 c 0.197 0.1 0.485 0.107 0.619 -0.067 c 0.07 -0.092 0.105 -0.241 0.105 -0.449 v -3.359 c 0 -0.22 -0.043 -0.386 -0.129 -0.5 c -0.147 -0.193 -0.42 -0.214 -0.632 -0.107 Z m 4.827 -5.195 c -2.604 -0.177 -11.066 -0.177 -13.666 0 c -2.814 0.192 -3.146 1.892 -3.167 6.367 c 0.021 4.467 0.35 6.175 3.167 6.367 c 2.6 0.177 11.062 0.177 13.666 0 c 2.814 -0.192 3.146 -1.893 3.167 -6.367 c -0.021 -4.467 -0.35 -6.175 -3.167 -6.367 Z m -12.324 10.686 h -1.363 v -7.54 h -1.41 v -1.28 h 4.182 v 1.28 h -1.41 v 7.54 Z m 4.846 0 h -1.21 v -0.718 c -0.223 0.265 -0.455 0.467 -0.696 0.605 c -0.652 0.374 -1.547 0.365 -1.547 -0.955 v -5.438 h 1.209 v 4.988 c 0 0.262 0.063 0.438 0.322 0.438 c 0.236 0 0.564 -0.303 0.711 -0.487 v -4.939 h 1.21 v 6.506 Z m 4.657 -1.348 c 0 0.805 -0.301 1.431 -1.106 1.431 c -0.443 0 -0.812 -0.162 -1.149 -0.583 v 0.5 h -1.221 v -8.82 h 1.221 v 2.84 c 0.273 -0.333 0.644 -0.608 1.076 -0.608 c 0.886 0 1.18 0.749 1.18 1.631 v 3.609 Z m 4.471 -1.752 h -2.314 v 1.228 c 0 0.488 0.042 0.91 0.528 0.91 c 0.511 0 0.541 -0.344 0.541 -0.91 v -0.452 h 1.245 v 0.489 c 0 1.253 -0.538 2.013 -1.813 2.013 c -1.155 0 -1.746 -0.842 -1.746 -2.013 v -2.921 c 0 -1.129 0.746 -1.914 1.837 -1.914 c 1.161 0 1.721 0.738 1.721 1.914 v 1.656 Z",
          }),
        ]),
    }),
  },
  {
    name: "Linkedin",
    href: "https://www.linkedin.com/company/79920733/admin/",
    icon: defineComponent({
      render: () =>
        h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
          h("path", {
            "fill-rule": "evenodd",
            d: "M 19 0 h -14 c -2.761 0 -5 2.239 -5 5 v 14 c 0 2.761 2.239 5 5 5 h 14 c 2.762 0 5 -2.239 5 -5 v -14 c 0 -2.761 -2.238 -5 -5 -5 Z m -11 19 h -3 v -11 h 3 v 11 Z m -1.5 -12.268 c -0.966 0 -1.75 -0.79 -1.75 -1.764 s 0.784 -1.764 1.75 -1.764 s 1.75 0.79 1.75 1.764 s -0.783 1.764 -1.75 1.764 Z m 13.5 12.268 h -3 v -5.604 c 0 -3.368 -4 -3.113 -4 0 v 5.604 h -3 v -11 h 3 v 1.765 c 1.396 -2.586 7 -2.777 7 2.476 v 6.759 Z",
            "clip-rule": "evenodd",
          }),
        ]),
    }),
  },
];

export default {
  setup() {
    return {
      navigation,
    };
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    setItem(policy) {
      localStorage.setItem("policy", policy);
    },
  },
};
</script>
